// The Project Approval guide (24_ProjectApproval.jsx · ModuleHelp, Max 01/11).
const en = {
  tabsT: 'Your queues',
  tabsB: 'Pending holds the projects waiting for approval (and date change requests); Rejected and Approved keep the decided ones. The number on each tab is how many are in it.',
  chartsT: 'What has been approved',
  chartsB: 'Approved projects by team and where they stand now. Click a bar to list exactly those projects below.',
  toolbarT: 'Find and act',
  toolbarB: 'Search by project, SKU or person; tick rows to approve or reject several at once.',
  listT: 'The projects',
  listB: 'One row per project with its SKUs. Open a row to see the details, the season and Target Launching, then approve or reject.',
};
const ko = {
  tabsT: '대기열',
  tabsB: '승인 대기에는 승인을 기다리는 프로젝트(일정 변경 요청 포함)가, 반려와 승인에는 결정된 프로젝트가 있습니다. 탭의 숫자는 건수입니다.',
  chartsT: '승인 현황',
  chartsB: '팀별 승인 프로젝트와 현재 상태입니다. 막대를 클릭하면 해당 프로젝트만 아래 목록에 나옵니다.',
  toolbarT: '찾기와 처리',
  toolbarB: '프로젝트, SKU, 담당자로 검색하고, 여러 행을 체크해 한 번에 승인·반려할 수 있습니다.',
  listT: '프로젝트 목록',
  listB: '프로젝트당 한 행과 SKU입니다. 행을 열어 상세, 시즌, Target Launching을 확인하고 승인 또는 반려합니다.',
};
const vi = {
  tabsT: 'Hàng chờ của bạn',
  tabsB: 'Chờ duyệt là các dự án đang đợi duyệt (kể cả yêu cầu đổi ngày); Từ chối và Đã duyệt giữ các dự án đã quyết. Số trên mỗi tab là số dự án trong đó.',
  chartsT: 'Những gì đã duyệt',
  chartsB: 'Dự án đã duyệt theo team và tình trạng hiện tại. Bấm một cột để liệt kê đúng các dự án đó bên dưới.',
  toolbarT: 'Tìm và xử lý',
  toolbarB: 'Tìm theo dự án, SKU hoặc người; tick nhiều dòng để duyệt hay từ chối cùng lúc.',
  listT: 'Danh sách dự án',
  listB: 'Mỗi dòng là một dự án kèm các SKU. Mở dòng để xem chi tiết, mùa và Target Launching, rồi duyệt hoặc từ chối.',
};
const zh = {
  tabsT: '您的队列',
  tabsB: '待审批中是等待审批的项目（含日期变更申请）；已拒绝和已批准保存已决定的项目。标签上的数字为数量。',
  chartsT: '已批准情况',
  chartsB: '按团队统计的已批准项目及其当前状态。点击柱条即可在下方只列出这些项目。',
  toolbarT: '查找与处理',
  toolbarB: '按项目、SKU 或人员搜索；勾选多行可一次批准或拒绝。',
  listT: '项目列表',
  listB: '每行一个项目及其 SKU。打开一行查看详情、季节和 Target Launching，然后批准或拒绝。',
};
// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "tabsT": "Vos files",
  "tabsB": "En attente contient les projets en attente d'approbation (et les demandes de changement de date) ; Rejetés et Approuvés conservent ceux déjà tranchés. Le nombre sur chaque onglet indique combien il en contient.",
  "chartsT": "Ce qui a été approuvé",
  "chartsB": "Projets approuvés par équipe et leur situation actuelle. Cliquez sur une barre pour lister exactement ces projets en dessous.",
  "toolbarT": "Trouver et agir",
  "toolbarB": "Recherchez par projet, SKU ou personne ; cochez des lignes pour approuver ou rejeter plusieurs projets à la fois.",
  "listT": "Les projets",
  "listB": "Une ligne par projet avec ses SKU. Ouvrez une ligne pour voir les détails, la saison et le lancement cible, puis approuvez ou rejetez."
};
const ja = {
  "tabsT": "あなたのキュー",
  "tabsB": "「保留中」は承認待ちのプロジェクト（および日付変更依頼）、「却下」と「承認済み」は判断済みのものです。各タブの数字は件数です。",
  "chartsT": "承認済みの内容",
  "chartsB": "承認済みプロジェクトをチーム別と現在の状況別に表示します。棒をクリックすると、該当するプロジェクトだけが下に表示されます。",
  "toolbarT": "探して操作する",
  "toolbarB": "プロジェクト、SKU、人名で検索します。行にチェックを入れると、複数をまとめて承認または却下できます。",
  "listT": "プロジェクト",
  "listB": "プロジェクトごとに1行で、SKU を表示します。行を開くと詳細、シーズン、ターゲットローンチを確認でき、そこで承認または却下します。"
};

const dictionary = { ns: 'tourPa', en, ko, vi, zh, fr, ja };
export default dictionary;
